class VonixPabxService {

	constructor (url) {
		this.baseUrl = url

		this.headers = new Headers()
		this.headers.append('Origin', location.href)
  }

  getSummary (agent) {
    return new Promise((resolve, reject) => {
			fetch(`${this.baseUrl}/api/agent/${agent}/summary.json`, {
				method: 'GET',
				headers: this.headers
			})
			.then(response =>response.json())
			.then(summary => resolve(summary))
			.catch(err => reject(new Error(err.message)))
    })
  }

	getPauseReasons () {
		return new Promise((resolve, reject) => {
			fetch(`${this.baseUrl}/api/pause_reasons.json`, {
				method: 'GET',
				headers: this.headers
			})
			.then(response =>response.json())
			.then(pauses => resolve(pauses))
			.catch(err => reject(new Error(err.message)))
		})
	}

	doLogin (agent, ramal) {
		return new Promise((resolve, reject) => {
			let headers = new Headers()
			headers.append("Origin", location.href);

      ramal = ramal.replace(/(:|\/|\-)/g, '')

      fetch(`${this.baseUrl}/api/agent/${agent}/login?location=${ramal}`, {
				method: 'POST',
				headers
			})
		});
	}

	doLogoff (agent) {
		return new Promise((resolve, reject) => {
			let headers = new Headers()
			headers.append("Origin", location.href);

			fetch(`${this.baseUrl}/api/agent/${agent}/logoff`, {
				method: 'POST',
				headers
			})
			.then(res => console.log(res.body))
		});
  }

}

export default VonixPabxService;



// WEBPACK FOOTER //
// ./src/service/VonixPabxService.js